import * as types from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';
import Vue from 'vue';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loader',
});

const mapToServerObject = user => {
    const data = _.pick(user, ['name', 'email']);

    if (user.id !== null) {
        if (user.password !== null && String(user.password).trim() !== '')
            data.password = user.password;
    } else {
        data.password = user.password;
    }

    data.outlets = user.outlets.map(o => o.id);
    data.roles = user.roles.map(r => r.name);

    return data;
};

export default {
    namespaced: true,
    state: {
        user: {
            id: null,
            name: null,
            email: null,
            password: null,
            outlets: [],
            roles: [],
        },
    },
    getters: {
        user: state => state.user,
        userExists: state => state.user.id !== null,
        userIsSuperAdmin: state => {
            return !!state.user.roles.find(r => r.name == 'inventory_admin');
        },
    },
    mutations: {
        [types.SET_USER](state, user) {
            state.user = user;
        },

        [types.SET_USER_ATTR](state, { key, value }) {
            Vue.set(state.user, key, value);
        },
    },
    actions: {
        async createUser({ getters, dispatch }) {
            const url = Laroute.route('users.create');
            startLoading(dispatch, 'save-user');

            try {
                const { data } = await axios.post(
                    url,
                    mapToServerObject(getters.user),
                );
                endLoading(dispatch, 'save-user');

                return data;
            } catch (e) {
                endLoading(dispatch, 'save-user');
                throw e;
            }
        },

        async updateUser({ getters, dispatch }) {
            const id = getters.user.id;
            const url = Laroute.route('users.update', { id });
            startLoading(dispatch, 'save-user');

            try {
                const { data } = await axios.put(
                    url,
                    mapToServerObject(getters.user),
                );
                endLoading(dispatch, 'save-user');

                return data;
            } catch (e) {
                endLoading(dispatch, 'save-user');
                throw e;
            }
        },

        async fetchUser({ dispatch, commit }, id) {
            const url = Laroute.route('users.show', { id });
            startLoading(dispatch, 'fetch-user');

            try {
                const { data } = await axios.get(url);
                commit(types.SET_USER, data);
                endLoading(dispatch, 'fetch-user');

                return data;
            } catch (e) {
                endLoading(dispatch, 'fetch-user');
                throw e;
            }
        },

        setUserAttr({ commit }, { key, value }) {
            commit(types.SET_USER_ATTR, { key, value });
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/user.js